import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const Context = {
  DEFAULT: 'DEFAULT',
  FOUNDRY_VTT: 'FOUNDRY_VTT',
  ROLL20: 'ROLL20',
};

export const useContext = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const context = new URLSearchParams(search).get('context');
    if (context?.startsWith('foundryvtt')) {
      return Context.FOUNDRY_VTT;
    }
    if (context === 'roll20') {
      return Context.ROLL20;
    }
    return Context.DEFAULT;
  }, [search]);
};

export const useFoundryVersion = () => {
  const { search } = useLocation();

  return useMemo(() => {
    const context = new URLSearchParams(search).get('context');
    if (context === 'foundryvtt' || context === 'foundryvtt13') {
      return 13;
    }
    if (context === 'foundryvtt12') {
      return 12;
    }
    if (context === 'roll20') {
      return null;
    }
    return null;
  }, [search]);
}
